export enum GmsStatus {
    GOOD = 'GOOD',
    WARNING = 'WARNING',
    ALARM = 'ALARM'
}
